var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-container__content" },
    [
      _c(
        "emd-alert",
        {
          attrs: { autoclose: false, title: _vm.title, variant: _vm.variant },
          on: {
            cancel: function ($event) {
              return _vm.$emit("cancel")
            },
          },
        },
        [
          _c(
            "template",
            { slot: "content" },
            _vm._l(_vm.alert.messages, function (message, index) {
              return _c("p", { key: index }, [
                _vm._v(" " + _vm._s(message) + " "),
              ])
            }),
            0
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }